function isPending2fa(state) {
	return state.session && state.session.use2fa === true && state.login && state.login.validated2fa === false;
}

function redirectToLoginWithCurrentRoute(vm) {
	if (!vm || !vm.$router) {
		return;
	}

	const currentRoute = vm.$router.currentRoute || {};
	const path = currentRoute.path || '/home';
	if (path === '/login') {
		return;
	}

	const query = { ...(currentRoute.query || {}) };
	query.redirect = path;
	vm.$router.replace({ path: '/login', query });
}

export default {
	puiLoginSessionExpired({ state, dispatch, commit }) {
		if (isPending2fa(state)) {
			redirectToLoginWithCurrentRoute(this.$app);
			return;
		}

		commit('puiLoginSessionExpired');
		dispatch('afterLogoutFunction');
	},

	async puiMenuGetLegalRequirements({ state }) {
		if (!state.httpRequestHeaders.Authorization) {
			return;
		}

		const {
			$app: { $puiRequests }
		} = this;

		try {
			const { data } = await $puiRequests.getRequest('/puivariable/getApplicationLegalText', null);

			if (data && data !== '-') {
				state.menu.legalRequirements.messageText = data;
				state.menu.legalRequirements.show = true;
			}
		} catch (error) {
			if (isPending2fa(state)) {
				redirectToLoginWithCurrentRoute(this.$app);
			}
		}
	},

	async puiMenuGetInfoMenu({ state, commit, getters }) {
		if (!state.httpRequestHeaders.Authorization) {
			return;
		}

		const {
			$app: { $puiRequests, $puiNotify }
		} = this;

		try {
			const { data } = await $puiRequests.getRequest('/puimenu/getMenu');
			commit('setMenuParentItems', null);
			commit('setMenuCurrentItems', data);
			commit('setMenuItems', data);
		} catch (error) {
			if (isPending2fa(state)) {
				redirectToLoginWithCurrentRoute(this.$app);
				return;
			}
			const message = getters.getTranslate('puimenu.errorLoadingMenu');
			$puiNotify.error(message);
		}
	},

	async getInfoModels({ state, dispatch, getters }) {
		if (!state.httpRequestHeaders.Authorization) {
			return;
		}

		const {
			$app: { $puiRequests, $puiNotify }
		} = this;

		try {
			const { data: models } = await $puiRequests.getRequest('/puimodel/getModelConfigurations', null);
			dispatch('getInfoElasticsearch', { models, getters });
			await dispatch('getCamundaModels', { models, getters });
			await dispatch('getInfoModelsWithDocgen', { models, getters });
		} catch (error) {
			if (isPending2fa(state)) {
				redirectToLoginWithCurrentRoute(this.$app);
				return;
			}
			const message = getters.getTranslate('pui9.error.errorLoadingModels');
			$puiNotify.error(message);
		}
	}
};

